/*
 * @Author: Michael 
 * @Date: 2019-03-13 10:54:39 
 * @Last Modified by: wufan
 * @Last Modified time: 2020-06-23 19:41:58
 * 微信分享注册
 */
import fetch from '@/common/api/fetch';
import store from '@/store';
import { AxiosPromiseData, ShareObjectInterface } from '@/common/interface';
import { wechatSignUp, wechatPreviewSignUp } from '@/common/utils/wechatFunc';

interface SignParam {
  url: string
}



// 获取微信签名， 参数为当前页面的url
function getWechatSign(): Promise<any> {

  const param: SignParam = {
    url: window.initUrl || window.location.href.split('#')[0]
  };
  return new Promise((resolve, reject) => {
    fetch.pureUrl('customer/anon/form/getWechatJSAPISignature', param).then((res: AxiosPromiseData): void => {
      store.dispatch('changeSignature', { signature: res.result })
      resolve(res.result);
    })
  })
}

// 微信分享API注册
export async function wechatShareConfig(shareObject: ShareObjectInterface) {
  const signature = await getWechatSign();
  if (signature) {
    wechatSignUp(signature, shareObject);
  }
}

// 微信图片上传API注册
export async function wechatPreviewConfig() {
  const signature = await getWechatSign();
  if (signature) {
    wechatPreviewSignUp(signature);
  }
}
